var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "date-range" },
    [
      _c("v-row", { staticClass: "date-component" }, [
        _c("span", [_vm._v("Interv. de:")]),
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.fromValue,
              expression: "fromValue"
            }
          ],
          attrs: {
            type: "date",
            title: "Data inicial",
            placeholder: "Data inicial",
            name: "from-date"
          },
          domProps: { value: _vm.fromValue },
          on: {
            change: _vm.changeRange,
            input: function($event) {
              if ($event.target.composing) {
                return
              }
              _vm.fromValue = $event.target.value
            }
          }
        }),
        _c("span", [_vm._v("até")]),
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.toValue,
              expression: "toValue"
            }
          ],
          attrs: {
            type: "date",
            title: "Data final",
            placeholder: "Data final",
            name: "to-date"
          },
          domProps: { value: _vm.toValue },
          on: {
            change: _vm.changeRange,
            input: function($event) {
              if ($event.target.composing) {
                return
              }
              _vm.toValue = $event.target.value
            }
          }
        }),
        _c(
          "button",
          {
            attrs: {
              type: "button",
              disabled: !(this.toValue || this.toValue)
            },
            on: { click: _vm.clearRange }
          },
          [_vm._v("X")]
        )
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }